export const getRegionFromRegionCode = (regionCode, regions) => regions.find((region) => region.code === regionCode);
//# sourceMappingURL=getRegionFromRegionCode.js.map